<div class="day" @fadeInAnimation>
  <div class="d-flex align-items-start">
    <div class="day-name mr-xlg" [ngClass]="{'shepherd-check': this.day === 1}">
      <label nz-checkbox [(ngModel)]="active" [disabled]="disabled" (ngModelChange)="changeActiveDay()">{{ day | getNameDay }}</label>
    </div>
    <ng-container *ngIf="active; else notAvailable">
      <div class="hour-range" *ngIf="timetable && active; else notHours">
        <div class="" *ngFor="let hourTable of timetable?.hourTable; index as k" [class.mb-xs]="k < timetable.hourTable.length -1" @fadeInAnimation>
          <div class="range">
            <nz-time-picker class="shepherd-time-start" [disabled]="disabled" [nzAllowEmpty]="false" nzFormat="HH:mm" [nzPlaceHolder]="'Inicia'" [ngModel]="hourTable | convertHourTable:'start'" (ngModelChange)="changeTime($event, 'start', k)"></nz-time-picker>
            <span class="ml-xs mr-xs">-</span>
            <nz-time-picker class="shepherd-time-end" [disabled]="disabled" [nzAllowEmpty]="false" nzFormat="HH:mm" [nzPlaceHolder]="'Termina'" [ngModel]="hourTable | convertHourTable:'end'" (ngModelChange)="changeTime($event, 'end', k)"></nz-time-picker>
            <div *ngIf="!disabled" nz-popover="" nzPopoverTitle="" nzPopoverPlacement="right" nzPopoverContent="Eliminar" class="ml-xs icon-action danger shepherd-time-delete" (click)="removeHourGroupToDay(k)"> <!-- && timetable.hourTable.length > 1 -->
              <i nz-icon nzType="delete" nzTheme="outline"></i>
            </div>
          </div>
          <p nz-typography [nzType]="'danger'" style="font-size: 0.7em" *ngIf="timetable.hourTable[k].hasError">{{ timetable.hourTable[k].hasError }}</p>
        </div>
      </div>
    </ng-container>
  </div>
  <i class="cursor-pointer text-info align-self-start plus-icon shepherd-time-plus-icon" *ngIf="active && !disabled" (click)="addHourGroupToDay()" nz-icon nzType="plus" nzTheme="outline"></i>
</div>

<ng-template #notAvailable>
  <p class="text-info align-self-center opacity-30">No disponible</p>
</ng-template>

<ng-template #notHours>
  <p class="text-info align-self-center opacity-30">No hay horarios</p>
</ng-template>
